import {
  RowDataReducerState,
  RowDataReducerAction,
} from "../../../../../types";
import { isNewRecord } from "../../../helpers";

const AR_SCHEDULE_CODE: Map<string, string[]> = new Map([
  [
    "Open-Item Receivable",
    ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  ],
  [
    "Balance-forward Receivable",
    ["N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y"],
  ],
]);

const AR_SCHEDULE_TYPE: Map<string, string> = new Map([
  ["Open-Item Receivable", "AR_OPEN"],
  ["Balance-forward Receivable", "AR_BAL"],
]);

const CUSTOM_AR_SCHEMA: Map<string, Map<string, string[]>> = new Map([
  ["sub_type", AR_SCHEDULE_CODE],
]);

export const getAccountsReceivableScheduleCodeandScheduleType = (
  propertyKey: string,
  rowDataReducerState: RowDataReducerState,
  dispatch: React.Dispatch<RowDataReducerAction>,
  subTypeValue: string | undefined,
): void => {
  const { rowData, resetState } = rowDataReducerState;
  if (isNewRecord(rowData)) {
    const scheduleCodeRange = CUSTOM_AR_SCHEMA.get(propertyKey)?.get(
      subTypeValue as string,
    );
    const existingScheduleCodes = rowDataReducerState.rowDataList.map(
      (row) => row["schedule_code"] as string,
    );
    const scheduleCodeToUpdate =
      scheduleCodeRange?.find(
        (code) => !existingScheduleCodes.includes(code),
      ) ?? null;

    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey: "schedule_code",
        newFieldValue: scheduleCodeToUpdate,
      },
    });

    // Need this to manage `Clear Changes` button state in New/Edit/Clone entries
    if (!scheduleCodeToUpdate) {
      dispatch({
        type: "UPDATE_ROW_DATA_REDUCER_STATE",
        payload: {
          resetState: {
            rowData: {
              ...resetState?.rowData,
              schedule_code: null,
            },
          },
        },
      });
    }

    const scheduleTypeToUpdate =
      AR_SCHEDULE_TYPE.get(subTypeValue as string) ?? null;

    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey: "schedule_type",
        newFieldValue: scheduleTypeToUpdate,
      },
    });
  }
};
